import React, { FC, ReactNode } from 'react';
import Collapsable, { CollapsableProps } from '../Collapsable';
import { StyledCollapsable, StyledContent, StyledArrow, StyledButton } from './LinkCollapse.styles';

export interface LinkCollapseProps extends Omit<CollapsableProps, 'title'> {
  /** The title of the collapse */
  title: ReactNode;
}

const LinkCollapse: FC<LinkCollapseProps> = ({ children, title, ...props }) => (
  <StyledCollapsable data-testid="LinkCollapse" {...props}>
    <Collapsable.Target>
      {({ toggle, isCollapsed }: {isCollapsed: boolean; toggle: React.MouseEventHandler<HTMLButtonElement>}) => (
        <StyledButton
          as="button"
          data-testid="LinkCollapseToggleButton"
          onClick={toggle}
        >
          <StyledArrow isCollapsed={isCollapsed} />
          {title}
        </StyledButton>
      )}
    </Collapsable.Target>
    <Collapsable.Content>
      <StyledContent>{children}</StyledContent>
    </Collapsable.Content>
  </StyledCollapsable>
);

export default LinkCollapse;
